var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiotLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "riot-logo_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#riot-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8.194L13.215 3 22 5.2v11.515l-3.635.447-1.45-8.225-.699.311.707 8.09-3.676.453-1.326-7.52-.692.307.646 7.38-3.635.447-1.205-6.836-.699.311.585 6.687-2.127.261L2 8.194zm11.663 11.982l-.185-1.047h.005L22 18.082v3.484l-8.337-1.39z",
    fill: "#CDDCFE"
  }))));
}
export default __webpack_public_path__ + "static/svg/riot-logo.svg";
export { SvgRiotLogo as ReactComponent };